import { call, put, takeLatest, select } from 'redux-saga/effects'
import { path } from 'ramda'
import { request, authenticatedCall } from 'shared/helpers/sagas'
import * as types from 'store/modal/modalTypes'
import API from 'store/modal/modalApis'

export function* tryCheckForNoShows ({ payload }) {
  yield* authenticatedCall('CHECK_FOR_NO_SHOWS', function* () {
    const data = yield call(API.checkForNoShows)
    if (data.timeSlot && data.interviewee) yield put({ type: 'SHOW_NO_SHOW_MODAL', payload: {...data, ...payload } })
    else if (payload && payload.nextAction) yield payload.nextAction()
  })
}

export function* tryMarkNoShow ({ payload }) {
  yield* authenticatedCall('MARK_PARTICIPANT_AS_NO_SHOW', function* () {
    const nextAction = yield select(path(['modal', 'noShowModal', 'state', 'nextAction']))
    yield call(API.markNoShow, payload)
    yield put({ type: 'MARK_PARTICIPANT_AS_NO_SHOW_SUCCEEDED' })
    if (nextAction) yield nextAction()
  })
}

export default function* watchCheckForNoShows () {
  yield takeLatest(types.CHECK_FOR_NO_SHOWS, tryCheckForNoShows)
  yield takeLatest(types.MARK_PARTICIPANT_AS_NO_SHOW_REQUESTED, tryMarkNoShow)
}
